import {useEffect, useState} from 'react'
// import {useLocation} from 'react-router-dom'
// import {
//   DrawerComponent,
//   ScrollTopComponent,
//   StickyComponent,
//   ToggleComponent,
// } from '../../assets/ts/components'
import {KTIcon} from '../../helpers'

function scrollToTop(smooth: boolean = false) {
  if (smooth) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  } else {
    document.documentElement.scrollTop = 0
  }
}

export function ScrollTop() {
  const [visible, setVisible] = useState(false)
  const top = 100

  useEffect(() => {
    const onScroll = () => {
      setVisible(document.documentElement.scrollTop >= top)
    }
    onScroll()
    document.addEventListener('scroll', onScroll)
    return () => document.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <div
      className='scrolltop'
      style={{
        display: visible ? 'flex' : 'none',
        opacity: visible ? 1 : 0,
      }}
      onClick={() => scrollToTop(true)}
    >
      <KTIcon iconName='arrow-up' />
    </div>
  )
}

// export function ScrollTop() {
//   const {pathname} = useLocation()
//   const isFirstRun = useRef(true)

//   const pluginsReinitialization = () => {
//     setTimeout(() => {
//       StickyComponent.reInitialization()
//       setTimeout(() => {
//         ToggleComponent.reinitialization()
//         DrawerComponent.reinitialization()
//       }, 70)
//     }, 140)
//   }

//   const scrollTop = () => {
//     ScrollTopComponent.goTop()
//   }

//   const updateHeaderSticky = () => {
//     const stickyHeader = document.body.querySelectorAll(`[data-kt-sticky-name="header"]`)
//     if (stickyHeader && stickyHeader.length > 0) {
//       const sticky = StickyComponent.getInstance(stickyHeader[0] as HTMLElement)
//       if (sticky) {
//         sticky.update()
//       }
//     }
//   }

//   useEffect(() => {
//     if (isFirstRun.current) {
//       isFirstRun.current = false
//     } else {
//       pluginsReinitialization()
//     }

//     updateHeaderSticky()
//     setTimeout(() => {
//       scrollTop()
//     }, 0)
//   }, [pathname])

//   return (
//     <div id='kt_scrolltop' className='scrolltop' data-kt-scrolltop='true'>
//       <KTIcon iconName='arrow-up' />
//     </div>
//   )
// }
